import { atom } from 'recoil';

import { SHELL_PORTAL } from 'lib/context/ShellContext/shellPortal';
import { sessionPersistEffect } from 'lib/helpers/sessionPersistedAtom';

const VIEWED_PRACTICES_STORAGE_KEY = 'myriad:viewed-practices';
const MAX_VIEWED_PRACTICES = 50;

const sanitize = (value) =>
  Object.fromEntries(
    Object.entries(value || {})
      .filter(([id, name]) => /^\d+$/.test(id) && typeof name === 'string')
      .slice(-MAX_VIEWED_PRACTICES)
  );

export const viewedPracticesState = atom({
  key: 'viewedPracticesState',
  default: {},
  effects: [
    sessionPersistEffect({
      storageKey: VIEWED_PRACTICES_STORAGE_KEY,
      sanitize,
      owner: SHELL_PORTAL.ADMIN
    })
  ]
});
